<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-1">
            <div v-if="!subcategoryMode" class="d-flex justify-content-between align-items-center">
                <h3 class="text-primary mb-2">
                    دسته‌بندی محصولات
                </h3>
                <b-button @click="showModalAddCategories" class="mb-2" variant="primary">
                    اضافه کردن
                </b-button>
            </div>
            <div v-else class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="text-primary mb-2">
                        مدیریت زیردسته
                    </h3>
                    <b-button @click="showModalAddSubCategories" variant="primary" class="mb-2">
                        اضافه کردن
                    </b-button>
                </div>
                <b-card>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <div @click="returnCategory" class="border-right pr-1 pointer">
                                <div class="text-center mb-50">
                                    <feather-icon icon="ArrowRightIcon" size="26" />
                                </div>
                                <div style="font-size: 13px;">بازگشت</div>
                            </div>
                            <div class="px-1">
                                <h5 class="d-flex align-items-center font-weight-bolder mb-50">
                                    {{ selectCategory.name_Fa }}
                                </h5>
                                <h5 class="mb-0">{{ `وضعیت: ${selectCategory.isActive ? 'فعال' : 'غیرفعال'}` }}</h5>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
            <div v-if="!loading">
                <b-row v-if="categoriesData.length">
                    <b-col v-for="(item, index) in categoriesData" :key="index" lg="4" md="6">
                        <b-card class="category-item"
                            :class="{ 'category-item-active': secondCategoryId == item.id || firstCategoryId == item.id }">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 class="text-overflow-ellipsis name-categorie-width pb-50">{{ item.name_Fa }}
                                    </h4>
                                    <div class="d-flex align-items-center">
                                        <h6 class="display-order-title-categories text-muted mb-0">ترتیب نمایش: {{
                                            item.order }}</h6>
                                        <span class="display-order-title-categories mx-50">-</span>
                                        <h6 class="mb-0" :class="item.isActive ? 'text-info' : 'text-warning'">
                                            {{ item.isActive ? 'فعال' : 'غیر فعال' }}
                                        </h6>
                                        <span class="mx-50">-</span>
                                        <h6 class="mb-0" :class="item.showInMenu ? 'text-info' : 'text-warning'">
                                            {{ item.showInMenu ? 'نمایش' : 'عدم نمایش' }}
                                        </h6>
                                        <span v-if="!subcategoryMode && item.subCategories.length"
                                            class="mx-50">-</span>
                                        <h6 v-if="!subcategoryMode && item.subCategories.length" class="text-info mb-0">
                                            {{ `${item.subCategories.length} زیردسته` }}
                                        </h6>
                                    </div>
                                </div>
                                <b-dropdown id="dropdown-bill" dropdown left variant="link" no-caret
                                    toggle-class="p-0 m-0">
                                    <template #button-content>
                                        <feather-icon icon="MoreVerticalIcon" size="22" class="text-primary" />
                                    </template>
                                    <b-dropdown-item v-if="subcategoryMode" @click="showModalEditSubCategories(index)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="EditIcon" size="18" />
                                            <span class="ml-50">ویرایش</span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!subcategoryMode" @click="showModalEditCategories(index)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="EditIcon" size="18" />
                                            <span class="ml-50">ویرایش</span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!subcategoryMode" @click="showModalSubCategories(item)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="CircleIcon" size="18" />
                                            <span class="ml-50">مدیریت زیردسته</span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="changeActiveStatus(item)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="RotateCwIcon" size="18" />
                                            <span class="ml-50">{{ item.isActive ? 'غیر فعال' : 'فعال' }}</span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="changeShowInMenu(item)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon :icon="item.showInMenu ? 'EyeOffIcon' : 'EyeIcon'"
                                                size="18" />
                                            <span class="ml-50">
                                                {{ item.showInMenu ? 'عدم نمایش در منو' : 'نمایش در منو' }}
                                            </span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="handlingChangeOrder(item.id)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="RepeatIcon" size="18" />
                                            <span class="ml-50">تغییر ترتیب نمایش</span>
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="showModalDeleteCategories(index)">
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="Trash2Icon" size="18" />
                                            <span class="ml-50">حذف</span>
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </b-card>
                        <!-------------------------------------- edit modal -------------------------------------->
                        <b-modal :id="`modal-edit-categories${index}`" title="ویرایش دسته" size="xl" centered
                            :hide-footer="true" title-class="font-weight-bolder">
                            <b-card-text>
                                <EditCategories @editCategories="editCategories" :index="index" :data="item" />
                            </b-card-text>
                        </b-modal>

                        <!-------------------------------------- edit modal -------------------------------------->
                        <b-modal :id="`modal-edit-sub-categories${index}`" title="ویرایش زیردسته" size="md" centered
                            :hide-footer="true" title-class="font-weight-bolder">
                            <b-card-text>
                                <EditSubCategories @editSubCategories="editSubCategories" :index="index" :data="item"
                                    :categoriesData="categoriesDataMain" />
                            </b-card-text>
                        </b-modal>
                        <!-------------------------------------- delete modal -------------------------------------->
                        <b-modal :id="`modal-delete-categories${index}`"
                            :title="subcategoryMode ? 'حذف زیردسته' : 'حذف دسته‌بندی'" centered :hide-footer="true"
                            title-class="font-weight-bolder">
                            <b-card-text class="p-1">
                                <h5 v-if="!subcategoryMode" class="text-center text-danger mb-3">
                                    با حذف این دسته‌بندی، تمام محصولات مرتبط حذف خواهد شد
                                </h5>
                                <h5 v-else class="text-center text-danger mb-3">
                                    با حذف این زیردسته، تمام محصولات مرتبط حذف خواهد شد
                                </h5>
                                <div class="d-flex align-items-center">
                                    <b-button @click="$bvModal.hide(`modal-delete-categories${index}`)"
                                        class="w-50 mr-1" variant="secondary">
                                        انصراف
                                    </b-button>
                                    <b-button :disabled="loadingDelete"
                                        @click="deleteCategories(item.id, `modal-delete-categories${index}`)"
                                        class="w-50" variant="danger">
                                        حذف
                                    </b-button>
                                </div>
                            </b-card-text>
                        </b-modal>

                    </b-col>
                </b-row>
                <h5 v-if="!categoriesData.length" class="d-flex align-items-center justify-content-center"
                    style="min-height: 60vh;">
                    موردی وجود ندارد
                </h5>
            </div>
            <!------------------------------- loading ------------------------------->
            <div v-if="loading">
                <loading />
            </div>
            <!------------------------------- modal add categories ------------------------------->
            <b-modal id="modal-add-categories" title="اضافه کردن دسته" size="xl" centered :hide-footer="true"
                title-class="font-weight-bolder">
                <AddCategories @addCategories="addCategories" />
            </b-modal>

            <!------------------------------- modal add Sub categories ------------------------------->
            <b-modal id="modal-add-sub-categories" title="اضافه کردن زیردسته" size="md" centered :hide-footer="true"
                title-class="font-weight-bolder">
                <AddSubCategories @addSubCategories="addSubCategories" :data="selectCategory" />
            </b-modal>
        </div>


        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormInput, BFormFile, BTable, VBTooltip, BPagination, BDropdown, BDropdownItem, BDropdownItemButton } from 'bootstrap-vue';
import AddCategories from '@/@core/components/categories/add.vue';
import EditCategories from '@/@core/components/categories/edit.vue';
import AddSubCategories from '@/@core/components/sub-categories/add.vue';
import EditSubCategories from '@/@core/components/sub-categories/edit.vue';
import { storeService } from '@core/services';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        BPagination,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BTable,
        BDropdownItem,
        BDropdown,
        BDropdownItemButton,
        EditCategories,
        AddCategories,
        AddSubCategories,
        EditSubCategories
    },
    mixins: [accessHandling],
    data() {
        return {
            loadingDelete: false,
            loading: false,
            loadingPage: false,
            isAdminIdentityVerified: false,
            storeId: null,
            filters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
            },
            categoriesData: [],
            categoriesDataMain: [],
            firstCategoryId: null,
            secondCategoryId: null,
            subcategoryMode: false,
            selectCategory: null
        }
    },
    methods: {
        returnCategory() {
            this.subcategoryMode = false
            this.getCategory()
        },
        showModalSubCategories(item) {
            this.selectCategory = item
            this.subcategoryMode = true
            this.categoriesData = item.subCategories
        },
        deleteCategories(id, modal) {
            this.loadingDelete = true;
            storeService.deleteCategories(this.storeId, id).then(({ data }) => {
                this.$notif({ type: 'success', title: !this.subcategoryMode ? 'دسته‌بندی با موفقیت حذف شد' : 'زیردسته با موفقیت حذف شد' });
                this.loadingDelete = false;
                this.getCategory();
            })
                .catch((err) => {
                    this.$bvModal.hide(modal)
                    this.loadingDelete = false;
                })
        },
        getCategory() {
            this.loading = true;
            storeService.getCategory(this.storeId).then(({ data }) => {
                this.categoriesDataMain = data
                if (!this.subcategoryMode) {
                    this.categoriesData = data
                    this.selectCategory = null
                    this.subcategoryMode = false
                }
                else {
                    let categoriesData = []
                    categoriesData = data
                    categoriesData.forEach(item => {
                        if (item.id == this.selectCategory.id) {
                            this.selectCategory = item
                            this.categoriesData = item.subCategories
                        }
                    });
                }
                this.loading = false;
            })
        },
        showModalAddCategories() {
            if (this.accessHandling('employee', 'categories_products_create')) {
                this.$bvModal.show('modal-add-categories');
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalAddSubCategories() {
            if (this.accessHandling('employee', 'categories_products_create')) {
                this.$bvModal.show('modal-add-sub-categories');
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalEditCategories(index) {
            if (this.accessHandling('employee', 'categories_products_create')) {
                this.$bvModal.show(`modal-edit-categories${index}`);
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalEditSubCategories(index) {
            if (this.accessHandling('employee', 'categories_products_create')) {
                this.$bvModal.show(`modal-edit-sub-categories${index}`);
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalDeleteCategories(index) {
            if (this.accessHandling('employee', 'categories_products_delete')) {
                this.$bvModal.show(`modal-delete-categories${index}`);
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        addCategories() {
            this.$bvModal.hide('modal-add-categories');
            this.getCategory();
        },
        editCategories(index) {
            this.$bvModal.hide(`modal-edit-categories${index}`);
            this.getCategory();
        },
        addSubCategories() {
            this.$bvModal.hide('modal-add-sub-categories');
            this.getCategory();
        },
        editSubCategories(index) {
            this.$bvModal.hide(`modal-edit-sub-categories${index}`);
            this.getCategory();
        },
        changeActiveStatus(item) {
            if (this.accessHandling('employee', 'categories_products_status_change')) {
                storeService.changeActiveStatusCategory(this.storeId, item.id, { isActive: !item.isActive }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.isActive = !item.isActive
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeShowInMenu(item) {
            if (this.accessHandling('employee', 'categories_products_status_change')) {
                storeService.changeShowInMenuCategory(this.storeId, item.id, { showInMenu: !item.showInMenu }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.showInMenu = !item.showInMenu
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        handlingChangeOrder(id) {
            if (this.accessHandling('employee', 'categories_products_order_change')) {
                if (this.firstCategoryId != id) {
                    if (!this.firstCategoryId) {
                        this.firstCategoryId = id
                        this.$notif({ variant: 'primary', title: 'یک مورد دیگر انتخاب کنید تا جا به جایی صورت گیرد' });
                    }
                    else {
                        this.secondCategoryId = id
                        this.changeOrder()
                    }
                }
                else {
                    this.firstCategoryId = null
                    this.secondCategoryId = null
                }
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeOrder() {
            storeService.changeOrderCategory(this.storeId, this.firstCategoryId, { secondCategoryId: this.secondCategoryId }).then(({ data }) => {
                this.firstCategoryId = null
                this.secondCategoryId = null
                this.$notif({ type: 'success' });
                this.getCategory();
            })
                .catch((err) => {
                    this.firstCategoryId = null
                    this.secondCategoryId = null
                    this.$notif({ type: 'error' });
                })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                this.loadingPage = false;
                if (this.isAdminIdentityVerified) {
                    this.getCategory();
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus();
    },
};
</script>

<style lang="scss">
.category-item {
    border: 2px solid #ffffff00;
}

.category-item-active {
    border: 2px solid #7166f0;
}

.name-categorie-width {
    width: 19vw;

    @media (max-width: 1299px) {
        width: 21vw;
    }

    @media (max-width: 1000px) {
        width: 19vw;
    }

    @media (max-width: 990px) {
        width: 33vw;
    }

    @media (max-width: 767px) {
        width: 70vw;
    }
}

.display-order-title-categories {
    @media (max-width: 767px) {
        display: none;
    }
}
</style>